import React, { useEffect } from "react";
import styles from "../styles/armas.module.css";

import ConfirmDeleteModal from "../../../components/ConfirmDeleteModal";
import InfoModal from "../../../components/InfoModal";
import { FaMagnifyingGlass, FaTriangleExclamation } from "react-icons/fa6";
import { deleteFileByUrl } from "../../../services/fileService";
import EnlacesField from "../../../components/EnlacesField";

import { fmt } from "../domain/format";
import { getCazaExpiryFromPersona, getLicArmasExpiryFromPersona } from "../domain/armasExpiry";
import { useArmas } from "../hooks/useArmas";

export default function Armas() {
  const {
    personas,
    tiposArma,
    titulares,
    personaById,
    titularById,
    list,

    q,
    setQ,

    toggleArma,
    isArmaOpen,
    toggleRep,
    isRepOpen,

    formVisible,
    setFormVisible,
    editingArma,
    formData,
    setFormData,
    fileGuiaArma,
    setFileGuiaArma,
    openCreate,
    handleEditArma,
    handleArmaChange,
    submitArma,

    repairVisible,
    selectedRepairArma,
    editingRepair,
    repairFormData,
    openRepair,
    closeRepair,
    handleRepairChange,
    submitRepair,

    showConfirm,
    setShowConfirm,
    setConfirmTarget,
    confirmDelete,
    requestDeleteArma,
    requestDeleteRepair,
    infoModal,
    setInfoModal,

    fetchAll,
  } = useArmas();

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return (
    <div className={styles.page}>
      <div className={`${styles.wrap} ${styles.stack}`}>
        <div className={styles.titlebar}>
          <h2>Armas</h2>
        </div>

        {/* Filtros/Acciones */}
        <div className={`${styles.card} ${styles["filters-row"]}`}>
          <input
            className={styles.input}
            placeholder="Buscar por modelo, marca, tipo, nº guía/serie, propietario, titular…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />

          <div className={styles.actionsRow}>
            <button type="button" className={`${styles.btn} ${styles.primary}`} onClick={openCreate}>
              + Nueva arma
            </button>
          </div>
        </div>

        <div className={styles.kpis}>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Total</span>
            <span className={styles["kpi-value"]}>{list.length}</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Asignadas</span>
            <span className={styles["kpi-value"]}>{list.filter((a) => !!a.personaId).length}</span>
          </div>
          <div className={styles.kpi}>
            <span className={styles["kpi-title"]}>Con reparaciones</span>
            <span className={styles["kpi-value"]}>
              {list.filter((a) => (a.reparaciones || []).length > 0).length}
            </span>
          </div>
        </div>

        {/* LISTA */}
        <section className={styles.section}>
          <div className={styles.stack}>
            {list.length === 0 ? (
              <div className={`${styles.card} ${styles.soft} ${styles.empty}`}>
                <h4 style={{ margin: 0 }}>
                  <FaMagnifyingGlass style={{ fontSize: "30px" }} />
                </h4>
                <p className={styles.muted}>Prueba con otro término de búsqueda o crea un arma.</p>
              </div>
            ) : (
              list.map((a) => {
                const open = isArmaOpen(a.id);
                const persona = a.personaId ? personaById[a.personaId] : null;
                const titular = a.titularId ? titularById[a.titularId] : null;

                const caza = titular ? getCazaExpiryFromPersona(titular) : null;
                const licArmas = titular ? getLicArmasExpiryFromPersona(titular) : null;
                const hasLicArmasIndefinida = titular?.licenciasArmas?.some((l) => l?.fechaIndefinida) ?? false;

                const resumen = [
                  a.tipoArmaDescripcion || "—",
                  a.calibre || "—",
                  persona ? `Propietario: ${persona.nombre} ${persona.apellidos}` : "Sin asignar",
                  a.numeroGuia ? "Nº guía: " + a.numeroGuia : "—",
                  a.numeroSerie ? "Nº serie: " + a.numeroSerie : "—",
                ]
                  .filter(Boolean)
                  .join(" • ");

                return (
                  <article
                    key={a.id}
                    className={`${styles["item-card"]} ${styles.accordion} ${open ? styles.open : ""}`}
                  >
                    <button
                      type="button"
                      className={styles["accordion-header"]}
                      onClick={() => toggleArma(a.id)}
                      aria-expanded={open}
                      aria-controls={`arma-body-${a.id}`}
                    >
                      <div className={styles["accordion-title"]}>
                        <strong>{a.marca}</strong>
                        <span className={styles.muted}>— {resumen}</span>

                        {caza?.status === "expired" && (
                          <FaTriangleExclamation
                            style={{ color: "#a40000", marginLeft: 6 }}
                            title="Licencia de caza caducada"
                            aria-label="Licencia de caza caducada"
                          />
                        )}
                      </div>
                      <span className={styles.chevron} aria-hidden>
                        ▾
                      </span>
                    </button>

                    <div id={`arma-body-${a.id}`} className={styles["accordion-body"]}>
                      <div className={styles["item-row"]}>
                        <div className={styles["grid-3"]}>
                          <div className={styles.field}>
                            <label className={styles.label}>Marca</label>
                            <div className={styles.muted}>{fmt.text(a.marca)}</div>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>País</label>
                            <div className={styles.muted}>{fmt.text(a.pais)}</div>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>Propietario</label>
                            <div className={styles.muted}>
                              {persona ? `${persona.nombre} ${persona.apellidos}` : "—"}
                            </div>
                          </div>
                        </div>

                        <div className={styles["grid-3"]}>
                          <div className={styles.field}>
                            <label className={styles.label}>Nº Guía</label>
                            <div className={styles.muted}>{fmt.text(a.numeroGuia)}</div>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>Nº Serie</label>
                            <div className={styles.muted}>{fmt.text(a.numeroSerie)}</div>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>Licencia de Armas (Titular)</label>
                            <span
                              className={`${styles.pill} ${!licArmas ? styles.ghost : ""}`}
                              style={
                                licArmas
                                  ? licArmas.status === "expired"
                                    ? { background: "#fde8e8", color: "#a40000" }
                                    : licArmas.status === "soon"
                                      ? { background: "#fff6e5", color: "#9a5b00" }
                                      : {}
                                  : { opacity: 0.6 }
                              }
                            >
                              {licArmas ? fmt.date(licArmas.dateISO) : hasLicArmasIndefinida ? "Indefinida" : "—"}
                            </span>
                          </div>
                        </div>

                        <div className={styles["grid-3"]}>
                          <div className={styles.field}>
                            <label className={styles.label}>Titular</label>
                            <div className={styles.muted}>
                              {titular ? `${titular.nombre} ${titular.apellidos}` : "—"}
                            </div>
                          </div>
                          <div className={styles.field}>
                            <label className={styles.label}>Licencia de caza (Titular)</label>
                            <span
                              className={styles.pill}
                              style={
                                !caza
                                  ? { opacity: 0.6 }
                                  : caza.status === "expired"
                                    ? { background: "#fde8e8", color: "#a40000" }
                                    : caza.status === "soon"
                                      ? { background: "#fff6e5", color: "#9a5b00" }
                                      : {}
                              }
                            >
                              {caza ? fmt.date(caza.dateISO) : "—"}
                            </span>
                          </div>
                        </div>

                        {/* Acciones arma */}
                        <div className={styles["item-actions"]}>
                          {a.rutaDocumentoGuiaArma && (
                            <div style={{ marginTop: 8 }}>
                              <a
                                href={a.rutaDocumentoGuiaArma}
                                target="_blank"
                                rel="noreferrer"
                                className={`${styles.btn} ${styles.ghost}`}
                              >
                                Ver documento
                              </a>
                            </div>
                          )}
                          {a.enlaces?.map((url, i) => (
                            <a
                              key={i}
                              href={url}
                              target="_blank"
                              rel="noreferrer"
                              className={`${styles.btn} ${styles.ghost}`}
                              title={url}
                              style={{ marginTop: 8 }}
                            >
                              Enlace {a.enlaces.length > 1 ? i + 1 : ""}
                            </a>
                          ))}
                          <button className={styles.btn} type="button" onClick={() => handleEditArma(a)}>
                            Editar
                          </button>
                          <button
                            className={`${styles.btn} ${styles.danger}`}
                            type="button"
                            onClick={() => requestDeleteArma(a.id)}
                          >
                            Eliminar
                          </button>
                        </div>

                        {/* Botón añadir reparación */}
                        <div className={styles["item-actions"]} style={{ justifyContent: "flex-start", paddingBottom: 6 }}>
                          <button type="button" className={styles.btn} onClick={() => openRepair(a)}>
                            + Añadir reparación
                          </button>
                        </div>

                        {(a.reparaciones || []).length === 0 ? (
                          <div className={styles["empty-inline"]}>No hay reparaciones.</div>
                        ) : (
                          <ul className={styles["rep-list"]}>
                            {a.reparaciones.map((r, idx) => {
                              const repKey = r.id ?? `idx-${idx}`;
                              const openR = isRepOpen(a.id, repKey);
                              const resumenRep = `${fmt.date(r.fechaInicio)} → ${fmt.date(r.fechaFin)} • ${fmt.money(r.precio)}`;

                              return (
                                <li key={repKey} className={`${styles["sub-acc"]} ${openR ? styles.open : ""}`}>
                                  <button
                                    type="button"
                                    className={styles["sub-acc-head"]}
                                    onClick={() => toggleRep(a.id, repKey)}
                                    aria-expanded={openR}
                                    aria-controls={`rep-body-${a.id}-${idx}`}
                                  >
                                    <span className={styles["sub-ttl"]}>{fmt.text(r.descripcion)}</span>
                                    <span className={styles["sub-acc-meta"]}>{resumenRep}</span>
                                    <span className={styles.chevron} aria-hidden>
                                      ▾
                                    </span>
                                  </button>

                                  <div id={`rep-body-${a.id}-${idx}`} className={styles["sub-acc-body"]}>
                                    <div className={styles["grid-4"]}>
                                      <div className={styles.field}>
                                        <label className={styles.label}>Descripción</label>
                                        <div className={styles.muted}>{fmt.text(r.descripcion)}</div>
                                      </div>
                                      <div className={styles.field}>
                                        <label className={styles.label}>Inicio</label>
                                        <div className={styles.muted}>{fmt.date(r.fechaInicio)}</div>
                                      </div>
                                      <div className={styles.field}>
                                        <label className={styles.label}>Fin</label>
                                        <div className={styles.muted}>{fmt.date(r.fechaFin)}</div>
                                      </div>
                                      <div className={styles.field}>
                                        <label className={styles.label}>Precio</label>
                                        <div className={styles.muted}>{fmt.money(r.precio)}</div>
                                      </div>
                                    </div>

                                    <div className={styles["item-actions"]}>
                                      <button className={styles.btn} type="button" onClick={() => openRepair(a, r)}>
                                        Editar
                                      </button>
                                      <button
                                        className={`${styles.btn} ${styles.danger}`}
                                        type="button"
                                        onClick={() => requestDeleteRepair(r.id)}
                                      >
                                        Eliminar
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </div>
                    </div>
                  </article>
                );
              })
            )}
          </div>
        </section>
      </div>

      {/* MODAL CREAR/EDITAR ARMA */}
      {formVisible && (
        <div className={styles["modal-overlay"]}>
          <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
            <form onSubmit={submitArma}>
              <h3>{editingArma ? "Editar arma" : "Nueva arma"}</h3>

              <div className={styles["grid-3"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Marca</label>
                  <input className={styles.input} name="marca" value={formData.marca} onChange={handleArmaChange} required />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Modelo</label>
                  <input className={styles.input} name="modelo" value={formData.modelo} onChange={handleArmaChange} />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>País</label>
                  <input className={styles.input} name="pais" value={formData.pais} onChange={handleArmaChange} />
                </div>
              </div>

              <div className={styles["grid-3"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Nº Guía</label>
                  <input className={styles.input} name="numeroGuia" value={formData.numeroGuia} onChange={handleArmaChange} />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Nº Serie</label>
                  <input className={styles.input} name="numeroSerie" value={formData.numeroSerie} onChange={handleArmaChange} />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Calibre</label>
                  <input className={styles.input} name="calibre" value={formData.calibre} onChange={handleArmaChange} required />
                </div>
              </div>

              <div className={styles["grid-3"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Tipo de arma</label>
                  <select name="tipoArma" value={formData.tipoArma || ""} onChange={handleArmaChange} required>
                    <option value="">— Selecciona tipo —</option>
                    {tiposArma.map((t) => (
                      <option key={t.codigo} value={t.codigo}>
                        {t.descripcion}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>Propietario</label>
                  <select
                    name="personaId"
                    value={formData.personaId}
                    onChange={(e) =>
                      setFormData((p) => ({
                        ...p,
                        personaId: e.target.value,
                        titularId: p.titularId === "" ? e.target.value : p.titularId,
                      }))
                    }
                    required
                  >
                    <option value="">— Sin propietario explícito —</option>
                    {personas.map((p) => (
                      <option key={p.id} value={String(p.id)}>
                        {p.nombre} {p.apellidos}
                        {p.nickname ? ` (@${p.nickname})` : ""}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.field}>
                  <label className={styles.label}>Titular</label>
                  <select
                    name="titularId"
                    value={formData.titularId}
                    onChange={(e) => setFormData((p) => ({ ...p, titularId: e.target.value }))}
                  >
                    <option value="">— Sin titular explícito (igual que propietario) —</option>
                    {titulares.map((p) => (
                      <option key={p.id} value={String(p.id)}>
                        {p.nombre} {p.apellidos}
                        {p.nickname ? ` (@${p.nickname})` : ""}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className={styles.field} style={{ marginTop: 30 }}>
                <label className={styles.label}>Guía de arma (subir PDF/imagen)</label>
                <div className={styles["file-row"]}>
                  <div className={styles["file-control"]} style={{ flex: 1 }}>
                    <input
                      className={styles["file-input"]}
                      type="file"
                      accept="image/*,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                      onChange={(e) => setFileGuiaArma(e.target.files?.[0] ?? null)}
                    />
                    {formData.rutaDocumentoGuiaArma && (
                      <button
                        type="button"
                        className={styles["file-remove-icon"]}
                        title="Quitar del formulario"
                        onClick={() => {
                          setFormData((prev) => ({ ...prev, rutaDocumentoGuiaArma: "" }));
                          setFileGuiaArma(null);
                        }}
                      >
                        Borrar
                      </button>
                    )}
                  </div>

                  {formData.rutaDocumentoGuiaArma && (
                    <button
                      type="button"
                      className={styles["eliminar-boton"]}
                      onClick={async () => {
                        if (!window.confirm("Esto borrará el archivo del servidor. ¿Continuar?")) return;
                        try {
                          await deleteFileByUrl(formData.rutaDocumentoGuiaArma);
                          setFormData((prev) => ({ ...prev, rutaDocumentoGuiaArma: "" }));
                          setFileGuiaArma(null);
                          alert("Archivo borrado del servidor");
                        } catch (e) {
                          console.error(e);
                          alert("No se pudo borrar el archivo en el servidor");
                        }
                      }}
                    >
                      Borrar de forma definitiva
                    </button>
                  )}
                </div>

                {formData.rutaDocumentoGuiaArma && (
                  <div className={styles["file-meta"]}>
                    <a href={formData.rutaDocumentoGuiaArma} target="_blank" rel="noreferrer">
                      Ver archivo subido
                    </a>
                  </div>
                )}

                <EnlacesField
                  value={formData.enlaces}
                  onChange={(enlaces) => setFormData((prev) => ({ ...prev, enlaces }))}
                  buttonClassName={styles.btn}
                  dangerButtonClassName={`${styles.btn} ${styles.danger}`}
                  inputClassName={styles.input}
                />
              </div>

              <div className={styles["modal-actions"]}>
                <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={() => setFormVisible(false)}>
                  Cancelar
                </button>
                <button type="submit" className={`${styles.btn} ${styles.primary}`}>
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL REPARACIÓN */}
      {repairVisible && (
        <div className={styles["modal-overlay"]}>
          <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
            <form onSubmit={submitRepair}>
              <h3>
                {editingRepair ? "Editar reparación" : "Nueva reparación"}{" "}
                {selectedRepairArma ? `— ${selectedRepairArma.modelo}` : ""}
              </h3>

              <div className={styles.field}>
                <label className={styles.label}>Descripción</label>
                <textarea name="descripcion" value={repairFormData.descripcion} onChange={handleRepairChange} required />
                <div className={styles.field}>
                  <label className={styles.label}>Precio</label>
                  <input
                    className={styles.input}
                    type="number"
                    step="0.01"
                    min="0"
                    name="precio"
                    value={repairFormData.precio}
                    onChange={handleRepairChange}
                    required
                  />
                </div>
              </div>

              <div className={styles["grid-3"]}>
                <div className={styles.field}>
                  <label className={styles.label}>Inicio</label>
                  <input type="date" name="fechaInicio" value={repairFormData.fechaInicio} onChange={handleRepairChange} required />
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Fin</label>
                  <input type="date" name="fechaFin" value={repairFormData.fechaFin} onChange={handleRepairChange} required />
                </div>
              </div>

              <div className={styles["modal-actions"]}>
                <button className={`${styles.btn} ${styles.ghost}`} type="button" onClick={closeRepair}>
                  Cancelar
                </button>
                <button className={`${styles.btn} ${styles.primary}`} type="submit">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showConfirm && (
        <ConfirmDeleteModal
          title="Confirmar eliminación"
          message="¿Estás seguro de que deseas eliminar este elemento? Esta acción no se puede deshacer."
          confirmWord="Eliminar"
          onClose={() => {
            setShowConfirm(false);
            setConfirmTarget(null);
          }}
          onConfirm={confirmDelete}
        />
      )}

      {infoModal.open && (
        <InfoModal
          title={infoModal.title}
          message={infoModal.message}
          onClose={() => setInfoModal({ open: false, title: "", message: "" })}
        />
      )}
    </div>
  );
}
